import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import unmountIcon from "assets/images/svg/Maintenance.svg";

export const stuckMetersListColumns = handleUnmount => [
  {
    title: "Barcode",
    dataIndex: "barcode",
    render: textFormatter,
  },
  {
    title: "Serial Number",
    dataIndex: "serial",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: textFormatter,
  },
  {
    title: "Meter Type",
    dataIndex: "type",
    render: textFormatter,
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    render: cellContent => textFormatter(cellContent && customDateFormatWithTime(cellContent)),
  },
  {
    dataIndex: "",
    title: "",
    width: "4%",
    render: row => (
      <ButtonGroup tooltipTitle="Unmount meter" icon={unmountIcon} handleClick={() => handleUnmount([row.id])} />
    ),
  },
];
